import { CartStatusTypes, CartStatusActionTypes } from "./cartStatusTypes";
import { StatusCartFilterRequest } from "@/main/models/request/quoteStatusFilterRequest";
import { KeyValueEnum } from "@/main/models/common";

export function getCartStatus(request: StatusCartFilterRequest): CartStatusActionTypes {
	return {
		type: CartStatusTypes.GET_CART_STATUS,
		payload: { request },
	};
}

export function saveCartStatus(
	data: KeyValueEnum[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): CartStatusActionTypes {
	return {
		type: CartStatusTypes.SAVE_CART_STATUS,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerCartStatus(): CartStatusActionTypes {
	return {
		type: CartStatusTypes.RESET_REDUCER_CART_STATUS,
	};
}
